module.exports = __webpack_public_path__ + "static/media/to-the-moon.b0e1f170.png";